import React from "react";
import { Card } from "@mui/material";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => {
  return {
    title: {
      color: theme.palette.primary.dark + " !important",
      fontWeight: 500,
      textTransform: "uppercase",
      opacity: (props) => (props.disabled ? 0.5 : 1),
      marginBottom: (props) => (props.disabled ? 0 : null),
      display: "flex",
      margin: 0,
      whiteSpace: "nowrap",
      alignItems: "center",
      "& .MuiIcon-root": {
        marginRight: theme.spacing(1),
      },
    },
    subHeader: {
      color: theme.palette.primary.dark + " !important",
      fontWeight: 500,
      textTransform: "uppercase",
      marginBottom: theme.spacing(0),
      //marginTop: theme.spacing(3)
    },
  };
});

export function CheckoutCard(props) {
  return (
    <Card
      square={true}
      elevation={0}
      {...props}
      sx={{
        fontSize: "15px",
        p: (theme) => (theme.clientType == "desktop" ? "32px" : 0),
      }}
    />
  );
}

export function CheckoutCardTitle(props) {
  const classes = useStyles(props);
  const theme = useTheme();
  return (
    <Box
      pt={theme.clientType == "desktop" ? 0 : props.active ? 4 : 2}
      px={theme.clientType == "desktop" ? 0 : 3}
      pb={props.active || theme.clientType != "desktop" ? 1 : 0}
    >
      <Typography
        gutterBottom
        variant="h5"
        component="h2"
        className={classes.title}
        sx={{
          fontSize: (theme) => {
            if (theme.clientType == "desktop") {
              return props.active ? "30px" : "20px";
            }
            return props.active ? "20px" : "15px";
          },
        }}
      >
        {props.complete && <Icon color="secondary">check_circle</Icon>}
        {props.children}
      </Typography>
    </Box>
  );
}

export function CheckoutCardContent(props) {
  const theme = useTheme();
  return <Box px={theme.clientType == "desktop" ? 0 : 3} {...props} />;
}

export function CheckoutCardList(props) {
  return <List sx={{ mb: 2 }} {...props} />;
}

export function CheckoutCardSubHeader({ children }) {
  const classes = useStyles();

  return (
    <Typography
      gutterBottom
      variant="h5"
      component="h5"
      className={classes.subHeader}
      sx={{
        fontSize: (theme) => (theme.clientType == "desktop" ? "20px" : "15px"),
      }}
    >
      {children}
    </Typography>
  );
}
